function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBgElem6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#000000",
    height: 121.7,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "14.5 5.0 108.1 121.7",
    width: 108.1,
    zoomAndPan: "magnify",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "change1_1"
  }, /*#__PURE__*/React.createElement("path", {
    color: "#000000",
    d: "m 77.308476,113.19615 c -3.287601,4.98552 -8.201534,8.85871 -13.776445,10.99976 -5.574911,2.14105 -11.781655,2.55701 -17.618331,1.2933 -5.836675,-1.26371 -11.288446,-4.18869 -15.650325,-8.26763 -4.36188,-4.07894 -7.632881,-9.29338 -9.519782,-14.95936 -2.982161,-8.954822 -2.4931,-18.657529 -1.659208,-28.058951 0.833893,-9.401422 1.973623,-18.943918 0.20135,-28.214364 -0.935333,-4.892561 -2.666253,-9.603359 -3.651557,-14.486102 -0.985304,-4.882742 -1.175382,-10.134457 0.881627,-14.671054 1.20646,-2.660768 3.150207,-4.963257 5.487337,-6.71627 2.33713,-1.753013 5.059425,-2.9652612 7.894202,-3.6718511 5.669555,-1.4131799 11.6748,-0.8099419 17.339918,0.6209231 5.665117,1.4308651 11.089367,3.664842 16.617222,5.55792 5.527855,1.893079 11.255647,3.46078 17.098638,3.480349 7.509068,0.02515 14.829521,-2.503037 22.335688,-2.713218 3.75308,-0.105091 7.5864,0.394922 10.97563,2.010393 3.38924,1.615472 6.30067,4.437213 7.50871,7.992114 0.65724,1.934045 0.79762,4.029262 0.50041,6.050191 -0.29721,2.020929 -1.02489,3.968166 -2.04144,5.739921 -2.0331,3.543508 -5.17066,6.337142 -8.55089,8.631478 -3.38024,2.294335 -7.03763,4.145104 -10.54659,6.237266 -3.508961,2.092161 -6.916928,4.468093 -9.539155,7.600804 -3.506317,4.188912 -5.41462,9.514776 -6.40281,14.887366 -0.988191,5.372591 -1.120101,10.859269 -1.469624,16.31079 -0.543278,8.473507 -1.740243,17.257775 -6.414575,24.346225 z",
    fill: "#0e486d",
    style: {
      InkscapeStroke: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgElem6);
export default __webpack_public_path__ + "static/media/bg-elem-6.1ff9311f6fa8680c7c3339236aef6beb.svg";
export { ForwardRef as ReactComponent };